type ParsedReviewRatingFilter = {
  type: string;
  value: string;
};

const reviewRating = ({ separator = "|" }) => {
  return {
    parse: (querystring: string) => {
      const filters = querystring.split(" ").filter((elem) => elem !== "");
      return filters.reduce((acc, curr) => {
        const [key, value] = curr.split(separator);
        return value && value !== ""
          ? [...acc, { type: key, value }]
          : [...acc];
      }, []);
    },
    stringify: (dataArray: ParsedReviewRatingFilter[]) => {
      const dataString = dataArray.reduce((acc, curr) => {
        const currString = `${curr.type}${separator}${curr.value}`;
        return `${acc}+${currString}`;
      }, "");
      return encodeURIComponent(dataString);
    },
  };
};

export default reviewRating;
